__turbopack_context__.v({
  "Arrow": "Tooltip-module-scss-module__FmPG3W__Arrow",
  "ArrowFill": "Tooltip-module-scss-module__FmPG3W__ArrowFill",
  "ArrowInnerStroke": "Tooltip-module-scss-module__FmPG3W__ArrowInnerStroke",
  "ArrowOuterStroke": "Tooltip-module-scss-module__FmPG3W__ArrowOuterStroke",
  "Popup": "Tooltip-module-scss-module__FmPG3W__Popup",
});
